<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 0.5V7.5L7 5.5L4.5 7.5V0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M2.5 0.5H13.5C14.052 0.5 14.5 0.948 14.5 1.5V14.5C14.5 15.052 14.052 15.5 13.5 15.5H2.5C1.948 15.5 1.5 15.052 1.5 14.5V1.5C1.5 0.948 1.948 0.5 2.5 0.5Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
